import { render, staticRenderFns } from "./addTemplateType.vue?vue&type=template&id=25b47c11&scoped=true&"
import script from "./addTemplateType.vue?vue&type=script&lang=js&"
export * from "./addTemplateType.vue?vue&type=script&lang=js&"
import style0 from "./addTemplateType.vue?vue&type=style&index=0&id=25b47c11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b47c11",
  null
  
)

export default component.exports